import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useLanguage } from "@/context/LanguageContext";
import { useAuth, formatApiError } from "@/context/AuthContext";

export default function Login() {
  const { t } = useLanguage();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back");
      navigate(params.get("next") || "/account");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="pt-32 pb-24 min-h-screen">
      <div className="max-w-md mx-auto px-6">
        <div className="overline mb-3">{t("auth.welcome_back")}</div>
        <h1 className="font-serif text-4xl leading-tight text-ink font-light mb-10">
          {t("auth.login_title")}
        </h1>
        <form onSubmit={submit} data-testid="login-form" className="space-y-6">
          <label className="block">
            <div className="overline mb-2">{t("contact.email")}</div>
            <input required type="email" value={form.email} onChange={upd("email")} data-testid="login-email" className="fld" />
          </label>
          <label className="block">
            <div className="overline mb-2">{t("auth.password")}</div>
            <input required type="password" value={form.password} onChange={upd("password")} data-testid="login-password" className="fld" />
          </label>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="px-8 py-3 bg-ink text-bg text-xs uppercase tracking-widest2 hover:bg-accent transition-colors disabled:opacity-60">
            {loading ? "…" : t("auth.sign_in")}
          </button>
        </form>
        <div className="mt-10 text-sm text-muted">
          {t("auth.no_account")}{" "}
          <Link to="/register" className="underline underline-offset-4 text-ink">{t("auth.create_account")}</Link>
        </div>
        <style>{`.fld{width:100%;background:transparent;border:0;border-bottom:1px solid #DDD8CD;padding:.5rem 0;outline:none;color:#141414;font-size:0.95rem}.fld:focus{border-color:#141414}`}</style>
      </div>
    </div>
  );
}
